import React from 'react'
import { TicketType } from 'api/Tickets/Types/TicketType'
import { Option, Select } from 'components/Select'

interface Props {
  myTicketsTypes: TicketType[]
  myTicketType: number
  onTicketsTypeChange: (type: number) => void
}
const MyTicketsTypeSelect: React.FC<Props> = ({
  myTicketsTypes = [],
  onTicketsTypeChange,
  myTicketType,
}: Props) => {
  const onChange = (value: number) => {
    onTicketsTypeChange(value)
  }

  return (
    <div className='mb-5 mt-2.5'>
      <Select
        value={myTicketType}
        placeholder='Select a type'
        className='w-full max-w-[200px]'
        onChange={onChange}
        data-test='filter-search-field'
      >
        {myTicketsTypes?.map(({ id, name }) => (
          <Option key={id} value={id}>
            {name}
          </Option>
        ))}
      </Select>
    </div>
  )
}

export default MyTicketsTypeSelect
